"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitle = exports.StyledHeader = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var StyledHeader = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__StyledHeader",
  componentId: "sc-1lh5cl8-0"
})(["display:flex;align-items:flex-start;"]);

exports.StyledHeader = StyledHeader;

var StyledTitle = /*#__PURE__*/_styledComponents["default"].h1.withConfig({
  displayName: "indexstyles__StyledTitle",
  componentId: "sc-1lh5cl8-1"
})(["flex:1;margin-bottom:0;word-break:break-word;"]);

exports.StyledTitle = StyledTitle;